import React, { useState } from 'react';
import '../css/EventLinkGeneration.css'; // Import the CSS file

function EventGeneration() {
  const [formData, setFormData] = useState({ event: '', when: '', where: '' });
  const [successMessage, setSuccessMessage] = useState('');
  const [isFormVisible, setFormVisible] = useState(true);
  const [isCopied, setCopied] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const submitForm = () => {
    fetch(`${process.env.REACT_APP_BACKEND_BASE_URL}/api/generateEvent`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          setSuccessMessage(data.link);
          setFormVisible(false);
        } else {
          alert(data.message);
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  };

  const copyLink = () => {
    navigator.clipboard.writeText(successMessage).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 3000);
    });
  };

  const reloadPage = () => {
    window.location.reload();
  };

  return (
    <div className="event-generation-container">
      <div className="logo-container">
        <img src={`${process.env.REACT_APP_ASSETS_URL}/logo.png`} alt="Logo" className="logo" />
      </div>
      <h2>Generazione Link Giftcard</h2>
      {isFormVisible ? (
        <form className="form" onSubmit={(e) => e.preventDefault()}>
          <label htmlFor="event">Nome Evento:</label>
          <input name="event" value={formData.event} onChange={handleChange} required />

          <label htmlFor="when">Quando:</label>
          <input name="when" value={formData.when} onChange={handleChange} required />

          <label htmlFor="where">Dove:</label>
          <input name="where" value={formData.where} onChange={handleChange} required />

          <button type="button" onClick={submitForm}>Conferma</button>
        </form>
      ) : (
        <div>
          <div id="success">{successMessage}</div>
          <div id="finalDiv">
            <button onClick={copyLink}>Copia il link</button>
            {isCopied && <p className="copied-message">Link copiato!</p>}
            <button onClick={reloadPage} style={{ backgroundColor: '#b85e32' }}>Genera un altro link</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default EventGeneration; 